export default __webpack_public_path__ + "static/media/AceiteDeCastañas.a359b7dd.jpeg";